import {gql} from '@apollo/client';

export const CONFIRM_BCP_CHECK_RESULT = gql`
    mutation ConfirmBcpCheckResult($id: Long!, $input: ConfirmCheckResultInput!) {
        confirmBcpCheckResult(id: $id, input: $input) {
            success
            code
            message
        }
    }
`;
